import { Loader } from '@googlemaps/js-api-loader'

const googlemaps = {}

googlemaps.install = (Vue) => {
  Vue.prototype.$googlemaps = new Loader({
    // ESTA API KEY DEBE SER OTRA EN PRODUCCION
    apiKey: 'AIzaSyDJjkFcQqy3SI6U-Qdq25qGHCGGMnZkWUY', // api key de powertrakker
    version: 'weekly',
    libraries: ['visualization'],
    language: 'en'
  })
}

export default googlemaps